import { Github, Linkedin, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/[0.06] pt-14 pb-8"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="relative h-7 w-7 grid place-items-center rounded-full bg-[#007AFF]/20 border border-[#007AFF]/40">
                <span className="h-2 w-2 rounded-full bg-[#00F0FF]" />
              </span>
              <span className="font-display text-lg font-extrabold tracking-tight">
                Brand<span className="text-[#00F0FF]">With</span>Abdo
              </span>
            </div>
            <p className="mt-5 text-slate-400 max-w-sm leading-relaxed">
              A premium tech consultancy building websites, systems and growth
              engines for ambitious UK companies.
            </p>

            <div className="mt-7 flex items-center gap-3">
              {[
                { icon: Linkedin, href: "#" },
                { icon: Twitter, href: "#" },
                { icon: Github, href: "#" },
              ].map((s, i) => (
                <a
                  key={i}
                  data-testid={`footer-social-${i}`}
                  href={s.href}
                  className="grid place-items-center h-10 w-10 rounded-full bg-white/[0.04] border border-white/10 hover:border-[#007AFF]/50 hover:bg-[#007AFF]/10 transition-colors"
                  aria-label="social"
                >
                  <s.icon className="h-4 w-4 text-slate-300" />
                </a>
              ))}
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-5">
              Studio
            </div>
            <ul className="space-y-3 text-slate-300">
              {["About", "Process", "Clients", "Contact"].map((l) => (
                <li key={l}>
                  <a
                    href={`#${l.toLowerCase()}`}
                    data-testid={`footer-link-${l.toLowerCase()}`}
                    className="hover:text-white transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-5">
              Services
            </div>
            <ul className="space-y-3 text-slate-300">
              {[
                "Website Development",
                "Business Systems & Automation",
                "Marketing & Growth",
                "Brand & Strategy",
              ].map((l) => (
                <li key={l}>
                  <a href="#services" className="hover:text-white transition-colors">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/[0.06] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} BrandWithAbdo. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            Made in London · Building globally
          </p>
        </div>
      </div>
    </footer>
  );
}
